import cn from 'classnames';
import Skeleton from 'react-loading-skeleton';

import ToggleButton from 'components/common/ToggleButton';
import { BOX_RECOMMENDER_PATHS } from 'lib/constants';

const BoxQuestionsToggles = ({ boxSignupData, handleBoxSignupAnswerClick, icons, pathname }) => {
  if (!boxSignupData?.answers) {
    return (
      <>
        <Skeleton count={3} className="my-1" height={32} />
        <Skeleton count={1} className="my-8" height={48} />
      </>
    );
  }

  const isMealtimesQuestion = boxSignupData.question === 'Which meals can we cover?';

  return (
    <>
      <div
        className={cn('mb-6 grid gap-2 bp1:mb-8 bp1:grid-cols-2', {
          'grid-cols-1': pathname !== BOX_RECOMMENDER_PATHS.BOX_DAYS,
          'grid-cols-2': pathname === BOX_RECOMMENDER_PATHS.BOX_DAYS,
        })}
      >
        {boxSignupData.answers.map(answer => (
          <div key={answer.name}>
            <ToggleButton
              id={answer.id}
              selected={answer.selected}
              handleClick={() => handleBoxSignupAnswerClick(answer)}
              className="w-full px-4 py-3 text-left"
              type="refreshToggle"
              role={isMealtimesQuestion ? 'checkbox' : 'radio'}
              icon={isMealtimesQuestion ? icons.iconMap[answer.name] : icons.iconMap[pathname]}
              textContainerClassName="w-full"
            >
              {answer.name}
            </ToggleButton>
          </div>
        ))}
      </div>
    </>
  );
};

BoxQuestionsToggles.propTypes = {
  boxSignupData: PropTypes.object,
  handleBoxSignupAnswerClick: PropTypes.func,
  icons: PropTypes.object,
  pathname: PropTypes.string,
};

export default BoxQuestionsToggles;
